export const licenceSlugsDictionary = [
  {
    slug: "freemium_pl_license",
    translationKey: "licenses.template_pocket_lab_discovery",
  },
  {
    slug: "unlimited_protein_license",
    translationKey: "licenses.template_focus_pack",
  },
  {
    slug: "bipea_partner_pl_license",
    translationKey: "licenses.template_unlimited_credit_pack",
  },
  {
    slug: "unlimited-license",
    translationKey: "licenses.template_unlimited_credit_pack",
  },
  {
    slug: "generic_pl_license",
    translationKey: "licenses.template_classic_credit_pack",
  },
];

const getLicenceTranslation = (slug: string): string => {
  const licence = licenceSlugsDictionary.find(
    (licence) => licence.slug === slug,
  );
  return licence?.translationKey ?? "licenses.template_other";
};

export default getLicenceTranslation;
